import React from 'react'

import { useForm } from '../../../../../packages/kiti/components/form/form/FormHandler'
import FieldTypeIconText from '../../../../../containers/fields/FieldTypeIconText'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import Scroll from '../../../../../packages/kiti/components/helpers/Scroll'
import Line from '../../../../../packages/kiti/components/helpers/Line'
import { useHasIntegrations } from '../../_load/IntegrationsLoader'
import Draggable from '../../../../../components/dnd/Draggable'
import Sticky from '../../../../../components/helpers/Sticky'

const ADDRESS_TYPE = 'address'
const INTEGRATION_TYPE = 'integration'

const TYPES = ['text', 'checkbox', 'date', 'datetime', 'number', 'email', 'select', 'gallery', 'signature']

const FieldTypeItem = ({ type }) => (
  <Draggable item={{ item: { type } }} type="FIELD" useMoveCursor>
    <Line />
    <Separator weight={4} />
    <FieldTypeIconText type={type} />
    <Separator weight={4} />
  </Draggable>
)

const FieldTypesList = () => {
  const form = useForm()
  const hasIntegration = useHasIntegrations()

  const hasAddressField = form?.some(field => field.type === ADDRESS_TYPE && !field.deleted)
  const conditionalAddressField = hasAddressField ? TYPES : [...TYPES, ADDRESS_TYPE]
  const validFields = hasIntegration ? [...conditionalAddressField, INTEGRATION_TYPE] : conditionalAddressField

  return (
    <Sticky>
      <Scroll maxHeight="75vh">
        {validFields.map(type => (
          <FieldTypeItem key={type} type={type} />
        ))}
        <Separator weight={46} />
      </Scroll>
    </Sticky>
  )
}

export default FieldTypesList
